// extracted by mini-css-extract-plugin
export default {"footer-images":"FooterImages_footer-images__HFLXP","item-container":"FooterImages_item-container__fBLPB","image-container":"FooterImages_image-container__Hn+xd"};